import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ChatGPTFAQ = () => {
 const [openItems, setOpenItems] = useState({});

 const faqs = [
 {
 id: 'legal',
 question: 'Is this ChatGPT Plus service legal?',
 answer: 'Yes, we provide legitimate shared access to ChatGPT Plus through authorized reseller partnerships and bulk subscriptions.',
 emoji: '🔐'
 },
 {
 id: 'ban',
 question: 'Will my ChatGPT Plus account get banned?',
 answer: 'Our professionally managed ChatGPT Plus accounts have a 99.9% success rate with proper usage guidelines and account isolation.',
 emoji: '🛡️'
 },
 {
 id: 'privacy',
 question: 'Is my ChatGPT data safe and private?',
 answer: 'Absolutely. We use bank-level 256-bit SSL encryption, complete data isolation between users, and GDPR-compliant operations. Each user\'s ChatGPT conversations are completely isolated with no cross-contamination or data sharing.',
 emoji: '🔒'
 },
 {
 id: 'speed',
 question: 'How quickly can I start using ChatGPT Plus?',
 answer: 'You\'ll receive your ChatGPT Plus access credentials within 5 minutes of purchase completion.',
 emoji: '⚡'
 },
 {
 id: 'satisfaction',
 question: 'What if I\'m not satisfied with the ChatGPT Plus service?',
 answer: 'We offer a 30-day money-back guarantee for your complete peace of mind with our ChatGPT Plus service.',
 emoji: '💰'
 },
 {
 id: 'difference',
 question: 'What\'s the difference between the plans?',
 answer: 'Official Account gives you exclusive personal access via ChatGPT.com. Account Renewal offers discounted renewal for existing accounts. Shared Access provides cost-effective access for multiple users with the same features but shared resources.',
 emoji: '🤔'
 },
 {
 id: 'features',
 question: 'Do I get all ChatGPT Plus features with all plans?',
 answer: 'Yes! All plans provide access to GPT-4o, o3, plugins, custom GPTs, and all premium ChatGPT Plus features.',
 emoji: '🔄'
 },
 {
 id: 'security',
 question: 'What security measures do you have in place?',
 answer: 'We implement bank-level security with 256-bit SSL encryption, secure payment processing, regular security audits, 24/7 system monitoring, and proactive issue detection. All user data is completely isolated with zero cross-contamination.',
 emoji: '🔐'
 }
 ];

 const toggleItem = (id) => {
 setOpenItems(prev => ({
 ...prev,
 [id]: !prev[id]
 }));
 };

 return (
 <section className="py-20 bg-white">
 <div className="container mx-auto px-4">
 <div className="text-center mb-16">
 <h2 className="text-4xl md:text-5xl font-bold text-ink-900 mb-4">
 Frequently Asked Questions
 </h2>
 <p className="text-xl text-ink-600 max-w-2xl mx-auto">
 Get answers to common questions about our ChatGPT Plus service
 </p>
 </div>

 <div className="max-w-3xl mx-auto">
 {faqs.map((faq) => (
 <div 
 key={faq.id} 
 className="mb-4 bg-white rounded-lg border border-ink-200 overflow-hidden"
 >
 <button
 onClick={() => toggleItem(faq.id)}
 className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-cream-100 transition-colors duration-200"
 >
 <div className="flex items-center pr-4">
 <span className="text-xl mr-3 flex-shrink-0">{faq.emoji}</span>
 <h3 className="text-lg font-semibold text-ink-900">
 {faq.question}
 </h3>
 </div>
 <span className="text-ink-500 flex-shrink-0">
 {openItems[faq.id] ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
 </span>
 </button>
 
 {openItems[faq.id] && (
 <div className="px-6 pb-5 border-t border-ink-100">
 <p className="text-ink-700 leading-relaxed pt-4">
 {faq.answer}
 </p>
 </div>
 )}
 </div>
 ))}
 </div>

 <div className="text-center mt-12">
 <p className="text-ink-600">
 Still have questions? Contact our support team at{' '}
 <a href="mailto:support@chatgptplus.com" className="text-black hover:underline font-medium">
 support@chatgptplus.com
 </a>
 </p>
 </div>
 </div>
 </section>
 );
};

export default ChatGPTFAQ;